import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadFormularyAndPricing, viewPriceDetails} from '../../Services/loadOrder';
import MenuBar from './MenuBar';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import FormularyModal from './FormularyModal';
import "../../assets/css/home.css";
import toast ,{ Toaster} from 'react-hot-toast'; 
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const FormularyPricingGrid = () => {
  const [rows, setRows] = useState([]);
  const [row, setRow] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const pharmacyID = user?.pharmacyId;
  const [names, setNames] = useState([]); // For dropdown values
  const [selectedName, setSelectedName] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedContract, setSelectedContract] = useState("Managed");
  const navigate = useNavigate();
     
  useEffect(() => {
    const searchFields = columns.map(col => ({
      label: col.headerName,
      field: col.searchField || col.field
    }));
    setNames(searchFields);
  }, []);
      
  const handleSearch = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const pharmacyId = user?.pharmacyId;
    const userId = user?.userId;
      
    if (!pharmacyId || !userId) {
      toast.error("Missing pharmacy or user info. Please login again.");
      navigate('/error-page');
      return;
    }
      
    setSearchLoading(true);
    try {
      const orderResponse = await loadFormularyAndPricing(selectedContract, 1, pharmacyId, "", selectedName, searchText);
      if (orderResponse.success) {
        const formattedRows = orderResponse.data.map((item, index) => ({
          id: item.NDC && item.NDC !== "" ? item.NDC + "-" + index : "row-" + index,
          ndc: item.NDC,
          drgName: item.DrgName || '',
          units: item.Units || '',
          gpiName: item.GPIName || '',
          awp: item.AWP,
          wac: item.WAC,
          discount: item?.['Discount % (PRR)'],
          reimburst: item?.["Reimburs't $ (PRP)"],
          effDate: item.EFFDate ? new Date(item.EFFDate).toLocaleDateString() : '',
          endDate: item.EndDate ? new Date(item.EndDate).toLocaleDateString() : '',
          formularyStatus: item.FormularyStatus || '',
          details: item.Details || '',
          pharmacyId,
          userId,
        }));
        setRows(formattedRows);
      } else {
        setRows([]);
        toast.error("No data found for the search.");
      }
    } catch (error) {
      toast.error("Error searching cost share details.");
      navigate('/error-page');
    } finally {
      setSearchLoading(false);
    }
  };

  const columns = [
    { field: 'ndc', headerName: 'NDC', flex:1, headerClassName: 'pink-header' },
    { field: 'drgName', headerName: 'Drug Name', flex:1.3, headerClassName: 'pink-header',
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            lineHeight: 1.3,
            padding: '10px 2px',
            width: '100%',
          }}
        >
          {params.value}
        </div>
      ),
    },
    { field: 'units', headerName: 'Units', flex:.8, headerClassName: 'pink-header' },
    { field: 'gpiName', headerName: 'GPI Name', flex:1.2, headerClassName: 'pink-header',
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            lineHeight: 1.5,
            padding: '10px 2px',
            width: '100%',
          }}
        >
          {params.value}
        </div>
      ),
    },
    { field: 'awp', headerName: 'AWP', flex:1, headerClassName: 'pink-header' },
    { field: 'wac', headerName: 'WAC', flex:.8, headerClassName: 'pink-header' },
    { field: 'discount', headerName: 'Discount',flex:1, headerClassName: 'pink-header' },
    { field: 'reimburst', headerName: "Reimburs't", flex:1, headerClassName: 'pink-header' },
    { field: 'formularyStatus', headerName: 'Formulary Status', flex:1.3, headerClassName: 'pink-header',
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            lineHeight: 1.5,
            padding: '10px 2px',
            width: '100%',
          }}
        >
          {params.value}
        </div>
      ),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const user = JSON.parse(localStorage.getItem('user'));
      const pharmacyId = user?.pharmacyId;
      const userId = user?.userId;
      if (!pharmacyId) return;

      const orderResponse = await loadFormularyAndPricing(selectedContract, 1, pharmacyId, "", selectedName, searchText);
      if (orderResponse.success) {
        const formattedRows = orderResponse.data.map((item, index) => ({
          id: item.NDC && item.NDC !== "" ? item.NDC + "-" + index : "row-" + index,
          ndc: item.NDC,
          drgName: item.DrgName || '',
          units: item.Units || '',
          gpiName: item.GPIName || '',
          awp: item.AWP,
          wac: item.WAC,
          discount: item?.['Discount % (PRR)'],
          reimburst: item?.["Reimburs't $ (PRP)"],
          effDate: item.EFFDate ? new Date(item.EFFDate).toLocaleDateString() : '',
          endDate: item.EndDate ? new Date(item.EndDate).toLocaleDateString() : '',
          formularyStatus: item.FormularyStatus || '',
          details: item.Details || '',
          pharmacyId,
          userId,
        }));
        setRows(formattedRows);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleRowClick = async (params) => {
    const row = params.row;
    const drgName = row.drgName;
    const flag = 2;
    console.log("Calling loadRxDetails with:", { drgName, pharmacyID, flag});

    if (!drgName || !pharmacyID || !flag) {
      toast.error("Missing required task or user data.");
      navigate('/error-page');
      return;
    }

    try {
      const rxResponse = await viewPriceDetails(flag, pharmacyID, drgName, "", "");
      console.log("Prescription details response:", rxResponse?.data);
      setRow(Array.isArray(rxResponse?.data) ? rxResponse.data : []);
      setOpenModal(true);

      if (rxResponse?.data) {
        console.log("Drug details:", rxResponse.data);
      } else {
        toast.error("No prescription data found.");
      }
    } catch (err) {
      console.error("Failed to load prescription details:", err);
      toast.error("Error loading prescription details.");
      navigate('/error-page');
    }
  };

  return (
    <>
      <Toaster position="top-right" />
      <div style={{ overflowX: 'hidden' }}>
        <div className='top-page-option'>
          <MenuBar />
          <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center' }}>
            <a href="#/home" style={{ textDecoration: 'none', color: '#ec088c', display: 'inline-flex', alignItems: 'center' }}>
              <ChevronLeft color='#ec088c' size={18} />
              <span style={{ marginLeft: '5px' }}>Back</span>
            </a>
          </div>
          <div
            className='top-page-option-name'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              padding: '10px 20px',
            }}
          >
            <span style={{ fontSize: 18 }}>Formulary & Pricing</span>
            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', gap: '8px', marginLeft: 'auto', marginRight: '9.09%' }}>
              <FormControl size="small" sx={{ minWidth: 100, height: '30px', background: '#fff', borderRadius: '4px', marginRight: '10px' }}>
                <InputLabel sx={{ fontFamily: 'Calibri', marginBottom: '10px', background: '#fff', color: 'black', fontSize: '12px' }}>
                  Managed
                </InputLabel>
                <Select
                  value={selectedContract}
                  onChange={(e) => setSelectedContract(e.target.value)}
                  label="Select"
                  sx={{
                    fontFamily: 'Calibri',
                    fontSize: '12px',
                    border: '1px solid rgba(236, 151, 202)',
                    borderRadius: '15px',
                    height: '30px',
                    boxShadow: 'none',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#ec008c',
                      boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#ec008c',
                    },
                  }}
                >
                  <MenuItem value="Managed" sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                    Managed
                  </MenuItem>
                  <MenuItem value="Consumer" sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                    Consumer
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 100, height: '30px', background: '#fff', borderRadius: '4px', marginRight: '10px' }}>
                <InputLabel sx={{ fontFamily: 'Calibri', marginBottom: '10px', background: '#fff', color: 'black', fontSize: '12px' }}>
                  --Select--
                </InputLabel>
                <Select
                  value={selectedName}
                  onChange={(e) => setSelectedName(e.target.value)}
                  label="Select"
                  sx={{
                    fontFamily: 'Calibri',
                    fontSize: '12px',
                    border: '1px solid rgba(236, 151, 202)',
                    borderRadius: '15px',
                    height: '30px',
                    boxShadow: 'none',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#ec008c',
                      boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#ec008c',
                    },
                  }}
                >
                  <MenuItem value="" sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                    --Select--
                  </MenuItem>
                  {names.map((item, idx) => (
                    <MenuItem key={idx} value={item.field} sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <input
                type="text"
                value={searchText}
                onChange={e => setSearchText(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') handleSearch(); }}
                style={{ padding: '5px 5px', borderRadius: '15px', border: '1px solid rgba(236, 151, 202)', outline: 'none', transition: 'all 0.3s ease' }}
                onFocus={(e) => {
                  e.target.style.border = '1px solid #ec008c';
                  e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
                }}
                onBlur={(e) => {
                  e.target.style.border = '1px solid rgba(236, 151, 202)';
                  e.target.style.boxShadow = '0 1px 2px rgba(236, 151, 202)';
                }}
              />
              <button
                onClick={handleSearch}
                disabled={searchLoading}
                style={{ padding: '6px 18px', borderRadius: '4px', background: '#ec008c', color: 'white', border: 'none', cursor: 'pointer' }}
              >
                {searchLoading ? <>
                  Searching&nbsp;&nbsp;
                  <CircularProgress size={15} sx={{ color: '#fff' }} />
                </> : 'Search'}
              </button>
              <button
                onClick={() => window.location.reload()}
                style={{ padding: '5px 18px', borderRadius: '4px', background: '#ec008c', color: 'white', border: 'none', cursor: 'pointer' }}
              >
                View All
              </button>
            </div>
          </div>
        </div>
        <div style={{ height: 'auto', width: '85%', margin: 'auto' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            onRowClick={handleRowClick}
            sx={{
              fontSize: '12px',
              fontFamily: 'Segoe UI',
              backgroundColor: 'ec008c',
              '& .pink-header': {
                color: '#fff',
                backgroundColor: '#ec008c',
                fontWeight: 'bold',
                whiteSpace: 'normal !important',
                wordBreak: 'breakWord !important',
                overflowWrap: 'breakWord !important',
                lineHeight: '1.3 !important',
                textAlign: 'center',
                padding: '8px 2px !important',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#f5f5f5 !important',
                cursor: 'pointer',
              },
              '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                outline: 'none !important',
                boxShadow: 'none !important',
                backgroundColor: 'none !important',  
              },
              '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                outline: 'none !important',
                boxShadow: 'none !important',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#ec008c',
                color: '#fff',
                fontWeight: 'bold',
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                lineHeight: 1.3,
                textAlign: 'center',
                padding: '8px 2px',
              }
            }}
          />
        </div>
        {(loading || searchLoading) && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(255,255,255,0.7)',
            zIndex: 2000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{
              border: '6px solid #f3f3f3',
              borderTop: '6px solid #EC088C',
              borderRadius: '50%',
              width: 48,
              height: 48,
              animation: 'spin 1s linear infinite'
            }} />
            <div style={{marginTop: 24, fontSize: '1.2rem', fontWeight: 500, color: '#222'}}>Your request is being processed</div>
            <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
          </div>
        )}
      </div>
      {openModal && (
        <FormularyModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          rows={row}
          disableConfirm={false}
          loading={loading}
          searchLoading={searchLoading}
        />
      )}
    </>
  );
};

export default FormularyPricingGrid;
